export default __webpack_public_path__ + "static/RTG_PDP_LOGO_BEDSTOGO_535x100-39c6c521fc85bf2e7564c85d8f87fbf9.png";